import React, { useState, useEffect } from 'react';
import { Table, Switch, message, Card, Button } from 'antd';
import { UserOutlined, BookOutlined } from '@ant-design/icons';
import api from '../api/axios';

function SchoolAppsManagement() {
  const [studentApps, setStudentApps] = useState([]);
  const [classApps, setClassApps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState('student');

  // 获取学生应用列表
  const fetchStudentApps = async () => {
    setLoading(true);
    try {
      const response = await api.get('/school/student-apps');
      setStudentApps(response.data.apps || []);
    } catch (error) {
      message.error('获取学生应用列表失败');
    } finally {
      setLoading(false);
    }
  };

  // 获取班级应用列表
  const fetchClassApps = async () => {
    setLoading(true);
    try {
      const response = await api.get('/school/class-apps');
      setClassApps(response.data.apps || []);
    } catch (error) {
      message.error('获取班级应用列表失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentApps();
    fetchClassApps();
  }, []);

  // 切换应用启用状态
  const handleToggleAppStatus = async (record, checked) => {
    try {
      const appType = record.app_type === 'student' ? 'student-apps' : 'class-apps';
      await api.put(`/school/${appType}/${record.id}`, { is_active: checked });
      message.success('更新成功');
      fetchStudentApps();
      fetchClassApps();
    } catch (error) {
      message.error('更新失败');
    }
  };

  // 获取应用子类型显示（主题/分类）
  const getAppSubTypeText = (type) => {
    if (type === 'theme') return '主题应用';
    if (type === 'category') return '分类应用';
    return type;
  };

  // 表格列
  const columns = [
    {
      title: '应用键',
      dataIndex: 'app_key',
      key: 'app_key',
      width: 150,
    },
    {
      title: '应用名称',
      dataIndex: 'app_name',
      key: 'app_name',
      width: 150,
    },
    {
      title: '应用子类型',
      dataIndex: 'app_subtype',
      key: 'app_subtype',
      width: 120,
      render: (text) => getAppSubTypeText(text),
    },
    {
      title: '应用图标',
      dataIndex: 'app_icon',
      key: 'app_icon',
      width: 100,
      render: (text) => text ? (
        <img src={text} alt="图标" style={{ width: 40, height: 40, objectFit: 'contain' }} />
      ) : '-',
    },
    {
      title: '访问URL',
      dataIndex: 'app_url',
      key: 'app_url',
      ellipsis: true,
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    {
      title: '排序',
      dataIndex: 'sort_order',
      key: 'sort_order',
      width: 80,
    },
    {
      title: '是否启用',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 100,
      render: (text, record) => (
        <Switch
          checked={text}
          onChange={(checked) => handleToggleAppStatus(record, checked)}
        />
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 180,
      render: (text) => text ? new Date(text).toLocaleString() : '-',
    },
  ];

  // 按类型分组
  const studentThemeApps = studentApps.filter(app => app.app_subtype === 'theme');
  const studentCategoryApps = studentApps.filter(app => app.app_subtype === 'category');
  const classThemeApps = classApps.filter(app => app.app_subtype === 'theme');
  const classCategoryApps = classApps.filter(app => app.app_subtype === 'category');

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>学校应用管理</h2>
        <div>
          <Button 
            type={currentTab === 'student' ? 'primary' : 'default'} 
            icon={<UserOutlined />} 
            onClick={() => setCurrentTab('student')}
            style={{ marginRight: 8 }}
          >
            学生应用
          </Button>
          <Button 
            type={currentTab === 'class' ? 'primary' : 'default'} 
            icon={<BookOutlined />} 
            onClick={() => setCurrentTab('class')}
          >
            班级应用
          </Button>
        </div>
      </div>

      {currentTab === 'student' && (
        <div>
          <Card title="主题应用" style={{ marginBottom: 16 }}>
            <Table
              columns={columns}
              dataSource={studentThemeApps}
              rowKey="id"
              loading={loading}
              pagination={false}
            />
          </Card>
          <Card title="分类应用">
            <Table
              columns={columns}
              dataSource={studentCategoryApps}
              rowKey="id"
              loading={loading}
              pagination={false}
            />
          </Card>
        </div>
      )}

      {currentTab === 'class' && (
        <div>
          <Card title="主题应用" style={{ marginBottom: 16 }}>
            <Table
              columns={columns}
              dataSource={classThemeApps}
              rowKey="id"
              loading={loading}
              pagination={false}
            />
          </Card>
          <Card title="分类应用">
            <Table
              columns={columns}
              dataSource={classCategoryApps}
              rowKey="id"
              loading={loading}
              pagination={false}
            />
          </Card>
        </div>
      )}
    </div>
  );
}

export default SchoolAppsManagement;